import '@/assets/css/styles.scss';

import { createApp } from 'vue';

import Highcharts from 'highcharts';
import VueHighcharts from 'vue-highcharts';
import LitepieDatepicker from 'litepie-datepicker';

import App from '@/App.vue';
import router from '@/router';
import { store } from '@/store';

import {
  setGlobalConfig,
  setGlobalFeatureFlags,
  setGlobalIntegrations,
  setUserPermissions,
} from './services/config';
import {
  translations,
  translationsState,
  genericTranslations,
  populateTranslations,
} from '@/plugins/localisation';

import { authState, setupAuth } from '@/services/integrations/auth0';
import { AppState } from './services/integrations/auth0/types';

const app = createApp(App);

const callbackRedirect = (appState: AppState) => {
  router.push(appState && appState.targetUrl ? appState.targetUrl : '/');
};

(async () => {
  app.provide('apiConnectionError', false);

  try {
    await setGlobalIntegrations();
  } catch (e) {
    app.use(genericTranslations);
    app.use(router);
    app.provide('apiConnectionError', true);
    app.mount('#app');
    return;
  }

  app.use(router);

  const auth = await setupAuth(callbackRedirect);
  await setGlobalFeatureFlags();

  if (authState.isAuthenticated.value) {
    await setGlobalConfig();
    await setUserPermissions();

    /* eslint-disable @typescript-eslint/no-unused-vars */
    const flower = function(x: number, y: number, w: number, h: number) {
      const r = Math.min(w, h) / 5,
        c1x = x + 1.5 * r,
        c1y = y + 3 * r,
        c2x = x + 3.75 * r,
        c2y = c1y,
        c3x = x + 2.5 * r,
        c3y = y + r;

      // prettier-ignore
      return [
        'M', c1x, c1y, 'a', r, r, 0, 1, 0, 0, -2 * r, 'a', r, r, 0, 1, 0, 0, 2 * r, 'z',
        'M', c2x, c2y, 'a', r, r, 0, 1, 0, 0, -2 * r, 'a', r, r, 0, 1, 0, 0, 2 * r, 'z',
        'M', c3x, c3y, 'a', r, r, 0, 1, 0, 0, -2 * r, 'a', r, r, 0, 1, 0, 0, 2 * r, 'z'
      ];
    };
    Highcharts.SVGRenderer.prototype.symbols.flower = flower;

    Highcharts.setOptions({
      lang: {
        locale: translationsState.locale || 'en-GB',
      },
    });

    populateTranslations();
    app.use(translations);

    app.use(store);
    app.use(VueHighcharts, { Highcharts });
    app.use(LitepieDatepicker);
  } else {
    app.use(genericTranslations);
  }
  app.use(auth).mount('#app');
})();
